import { MDXRemote } from "next-mdx-remote";
import { getFiles, getFileBySlug } from "~/lib/mdx";
import BlogLayout from "~/layouts/blog";
import MDXComponents from "~/components/MDXComponents";
import BlogSeo from "~/components/BlogSeo";
import { madeWithLinks, madeWithSentence } from "~/lib/blog";
import { BASE_URL } from "#next-seo.config";

export default function Blog({ mdxSource, frontMatter }) {
  return (
    <>
      <BlogSeo url={`${BASE_URL}/blog/${frontMatter.slug}`} {...frontMatter} />
      <BlogLayout frontMatter={frontMatter} showSubscribe={false}>
        <MDXRemote {...mdxSource} components={MDXComponents} />
      </BlogLayout>
    </>
  );
}

export async function getStaticPaths() {
  const posts = await getFiles("blog");

  return {
    paths: posts.map((p) => ({
      params: {
        slug: p.replace(/\.mdx/, "")
      }
    })),
    fallback: false
  };
}

export async function getStaticProps({ params }) {
  const post = await getFileBySlug("blog", params.slug);
  // Fails the build on a malformed list or link; the layout renders them.
  const { madeWith, madeWithLinks: links } = post.frontMatter as { madeWith?: unknown; madeWithLinks?: unknown };
  madeWithSentence(madeWith, params.slug);
  madeWithLinks(links, madeWith, params.slug);

  return { props: post };
}
